module.exports = __webpack_public_path__ + "img/DSC_3084.703dbe3e.jpg";